import { render, staticRenderFns } from "./WidgetSandbox.vue?vue&type=template&id=6e9f95f9&lang=pug"
import script from "./WidgetSandbox.vue?vue&type=script&lang=js"
export * from "./WidgetSandbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports